import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { TopMarquee, Header, CapabilitiesMarquee } from "@/components/site/Top";
import { Hero, BrandStatement } from "@/components/site/HeroBrand";
import { Services, Features, Benefits } from "@/components/site/Sections";
import { GrassInterlude } from "@/components/site/Canvases";
import { Approach, Faq, FinalCta, Footer } from "@/components/site/Lower";
import { FloatingNav, Assistant, CallButton, InquiryModal } from "@/components/site/Widgets";

export default function App() {
  const [inquiry, setInquiry] = useState({ open: false, service: "" });

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lenis = null;
    let raf = null;
    if (!reduced) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.__lenis = lenis;
      const tick = (t) => { lenis.raf(t); raf = requestAnimationFrame(tick); };
      raf = requestAnimationFrame(tick);
    }
    const onInquiry = (e) => setInquiry({ open: true, service: e.detail?.service || "" });
    window.addEventListener("pgl:inquiry", onInquiry);
    return () => {
      window.removeEventListener("pgl:inquiry", onInquiry);
      if (raf) cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const close = useCallback(() => setInquiry((s) => ({ ...s, open: false })), []);

  return (
    <div className="App bg-cream text-charcoal font-body overflow-x-clip">
      <TopMarquee />
      <div className="h-2.5 bg-cream" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <CapabilitiesMarquee />
        <BrandStatement />
        <Services />
        <GrassInterlude />
        <Features />
        <Benefits />
        <Approach />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <FloatingNav />
      <Assistant />
      <CallButton />
      <InquiryModal open={inquiry.open} service={inquiry.service} onClose={close} />
      <Toaster position="top-center" richColors />
    </div>
  );
}
